import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { GetPreview } from 'src/components';
import { useTranslation } from 'src/hooks';
import { templatesActions } from 'src/store/actions';
import { setRedirectTo, setShowCvPreview } from 'src/store/reducers/templates.reducer';

const Templates = () => {
  const fixWaiter = useSelector((state) => state.templatesReducer.fixWaiter);
  const dispatch = useDispatch();
  const { translate } = useTranslation();
  const navigate = useNavigate();
  const { subscription } = useSelector((state) => state.authReducer.user);
  const { id, template } = useSelector((state2) => state2.templatesReducer.currentResume);
  const resumeTemplates = useSelector((state2) => state2.templatesReducer.resumeTemplates);

  const [preview, setPreview] = useState('');
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    if (preview) {
      setShowPreview(false);
      const file = new File([preview], 'file');
      dispatch(templatesActions.resumesUploadPreview({ image: file, id })).then(() => {
        if (subscription) {
          dispatch(setShowCvPreview(true));
        } else {
          dispatch(setRedirectTo(`/my-cv/create/templates/?id=${id}`));
          navigate(`/choose/`);
        }
      });
    }
  }, [preview]);

  const handleSubmit = async (values) => {
    await dispatch(templatesActions.resumeTemplate(values));
    setShowPreview(true);
  };

  const formik = useFormik({
    initialValues: {
      id: id || '',
      template: (template && template.id) || (resumeTemplates.length && resumeTemplates[0].id),
      step: 7,
    },

    enableReinitialize: true,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <>
      {showPreview && <GetPreview setPreview={setPreview} />}
      <form className="create__templates" onSubmit={formik.handleSubmit}>
        <div className="create__templates__t">Choose a template</div>
        <div className="templates__wrap templates__wrap--colonmob">
          {resumeTemplates &&
            resumeTemplates.map((temp) => (
              <div
                className={`templates__item ${formik.values.template === temp.id ? 'active' : ''}`}
                key={temp.id}
              >
                <div className="templates__name">{temp.name}</div>
                <div className="templates__img">
                  <img src={temp.preview} alt="template" />
                  <button
                    type="button"
                    className="btn btn-primary s1__link"
                    onClick={() => formik.setFieldValue('template', temp.id)}
                  >
                    {translate('cv_create.choose')}
                  </button>
                </div>
                <div className="template__des">{temp.description}</div>
              </div>
            ))}
        </div>
        <div className="create__templates__btns">
          <Link to={`/my-cv/create/languages?id=${id}`} className="btn btn-outline-primary">
            {translate('cv_create.edit_resume')}
          </Link>
          <button type="submit" className="btn btn-primary" disabled={fixWaiter}>
            {fixWaiter ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="sr-only">{translate('loading')}</span>
              </>
            ) : (
              <>{translate('cover_create.save_continue')}</>
            )}
          </button>
        </div>
      </form>
    </>
  );
};

export default Templates;
